import { render, staticRenderFns } from "./RecoveryPasswordModal.vue?vue&type=template&id=0f21dd58"
import script from "./RecoveryPasswordModal.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports